import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import "./autoComplete.css";
export default function AutocompleteText(props) {
  const {  label, onChange, name, is_disabled = false } = props;
  return (
    // <Stack spacing={1} sx={{ width: 450 }}>
    <Autocomplete
      id="free-solo-demo"
      freeSolo
      disableClearable={is_disabled}
      disabled={is_disabled}
      forcePopupIcon={true}
      getOptionLabel={(option) => option}
      style={{ width: "100%" }}
      renderInput={(params) => (
        <TextField {...params} label={label} margin="normal" />
      )}
      onInputChange={(event, value) => {
        if (onChange) {
          onChange({ target: { name, value } });
        }
      }}
      {...props}
      onChange={() => {}}
    />
    // </Stack>
  );
}
